import React from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';

const FloatingDonateButton = () => {
  return (
    <>
      <style>{`
        @keyframes heartbeat {
          0%, 100% {
            transform: scale(1);
          }
          8% {
            transform: scale(1.12);
          }
          16% {
            transform: scale(0.92);
          }
          24% {
            transform: scale(1.08);
          }
          32% {
            transform: scale(0.96);
          }
          40%, 100% {
            transform: scale(1);
          }
        }
        @keyframes heartColor {
          0%, 100% {
            fill: white;
          }
          8% {
            fill: #ef4444;
          }
          16% {
            fill: white;
          }
          24% {
            fill: #ef4444;
          }
          32% {
            fill: white;
          }
          40%, 100% {
            fill: white;
          }
        }
        .heartbeat {
          animation: heartbeat 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }
        .heartbeat-color {
          animation: heartColor 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }
      `}</style>
      <Link to="/donate" target="_blank" rel="noopener noreferrer">
        <button className="fixed bottom-8 right-8 z-40 bg-warm-amber hover:bg-amber-600 text-white px-6 py-4 rounded-full shadow-2xl flex items-center space-x-2 transition-all duration-300 hover:scale-110 heartbeat">
          <Heart className="w-5 h-5 heartbeat-color" fill="white" />
          <span className="font-semibold">Donate</span>
        </button>
      </Link>
    </>
  );
};

export default FloatingDonateButton;